<template>
  <div class="content">
    <div class="search-box justify-align" ref="getheight">
      <img @click="onClickLeft" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="" />
      <div class="search-box-sec left-justifying">
        <img :src="require('../../assets/'+appTheme+'/search_icon.png')" alt="" />
        <div class="searchInput" type="text" @click="onSearch">搜一搜 </div>
      </div>
    </div>
    <div class="content-cate">
      <van-tree-select :main-item-class="itemclass" :height="wh" :items="items" :main-active-index.sync="active" @click-nav="clickNav">
        <template #content>
          <div class="classify-box">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
              <van-swipe-item v-for="(item,k) in bannerList" :key="k" @click="clickDes(item.href)"><img class="cover-img" :src="item.image" /></van-swipe-item>
            </van-swipe>
            <!--            <img class="cover-img" :src="currItem.banner" />-->
            <div class="shop-box">
              <h5>{{currItem.text}}</h5>
              <div class="shop-list">
                <div class="shop-item" v-for="(item,index) in currItem.children" :key="index" @click="goDes(item.id)">
                  <img class="shop-img" :src="item.icon" alt="">
                  <div class="title">{{item.text}}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </van-tree-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "classify",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      searchValue: '',
      active: 0,
      items: [],
      currItem: '',
      curr: 0,
      wh:'500px',
      itemclass:'',
      bannerList:[]
    }
  },
  mounted() {
    window.addEventListener("pagehide", this.pageHide);
    this.$nextTick(()=>{ // 页面渲染完成后的回调
      let heightCss = this.$refs.getheight.offsetHeight;
      // console.log(heightCss)
      let wh = document.documentElement.clientHeight
      this.wh = (wh-heightCss-50) + 'px'
    })
  },
  activated() {
    console.log('activated',this.$route.meta.isBack)
    if (!this.$route.meta.isBack) { // false// 后续进入：beforeRouteEnter => activated => deactivated,
      //isBack 时添加中router中的元信息，判读是否要缓存
      //清空原有数据
      this.currItem = ''
      this.curr = 0
      this.bannerList = []
      this.currItem = ''
      this.itemclass =''
      this.active =0
      this.getCategory() // 重新加载
      // console.log('activated不缓存')
    } else {
      // console.log('activated缓存')
    }
    this.$route.meta.isBack = false; // 通过这个控制刷新，否则会一直为true
  },
  beforeRouteLeave(to, from, next) { // 列表页面跳转到 详情页时，设置需要缓存 to: 即将要进入的目标 用一种标准化的方式 //from: 当前导航正要离开的路由 用一种标准化的方式
    // 去除背景色
    console.log('离开界面离开界面')
    if (to.path == '/classifyList') { // goodClassify
      //当离开的时候不是去首页的时候开启缓存
      from.meta.isBack = true;
      // console.log('open缓存meta',from.meta)
    }else {
      from.meta.isBack = false;
      // console.log('close缓存meta',from.meta)
    }
    next()
  },
  created() {
    console.log('created',this.$route.meta.isBack)
    // var wh = document.documentElement.clientHeight
    // this.wh = (wh+60) + 'px'
    // this.getCategory()
  },
  methods: {
    clickDes(url){ // 详情页
      console.log(url)
      var url = url
      if (url != null || url != undefined){
        window.open(url)
      } else {
        // console.log('null,undefined',url)
      }
    },
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.push('/');
        return false
      } else {
        this.$router.go(-1);
      }
    },
    async getCategory () {
      const res = await this.$Http.getCategoryList()
      if (res.code == 200){
        // console.log('res',res)
        var arr = res.data
        var arr = JSON.parse(JSON.stringify(arr).replace(/name/g,'text'))
        this.items = arr
        this.bannerList = arr[0].banners
        // console.log(arr[0])
        this.currItem = arr[0]
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    clickNav(index){
      console.log(index)
      this.curr = index
      this.currItem = this.items[index]
      this.bannerList = this.items[index].banners
    },
    onSearch(){
      this.$router.push('/searchList');
    },
    goDes(id){
      this.$router.push({path:'/classifyList',query: {id:id}})
    },
  }
}
</script>

<style lang="scss" scoped>
.my-swipe .van-swipe-item {
  width: 470px;
  height: 177px;
}
/deep/.van-sidebar {
  width: 0.8rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.van-tree-select__nav {
  webkit-box-flex: 0.75;
  -webkit-flex: 0.75;
  flex: 0.75;
}
.search-box{
  padding: 34px 42px 34px 27px;
  background: #FDD80D;
  img{
    width: 22px;height: auto;display: inline-block;
  }
  .search-box-sec{
    width: 590px;
    height: 60px;
    line-height: 60px;color: #8C8C8C;font-size: 24px;
    background: #FFFFFF;
    opacity: 0.63;
    border-radius: 30px;text-align: left;padding-left: 28px;
    img{
      width: 34px;height: auto;display: inline-block;
    }
    .searchInput{
      height: 60px;
      line-height: 60px;width: 500px;margin-left: 10px;border: none;background: none;color: #282828;font-size: 28px;
    }
  }
}
.van-sidebar-item--select::before {
  top: 0;height: 100%;
  background-color: #f7f8fa;width: 0px;
}
.van-tree-select{
  color: #282828;font-size: 30px;
}
.van-sidebar-item--select, .van-sidebar-item--select:active {
  font-weight: bold;border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.classify-box{
  padding-top: 20px;
  .cover-img{
    width: 470px;
    height: 177px;
    border-radius: 12px;margin: 0 auto;
  }
}
.shop-box{
  font-size: 26px;
  h5{
    text-align: left;padding: 0 30px;font-size: 30px;margin: 32px 0 30px;
  }
  .shop-list{
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;padding-left: 20px;
    .shop-item{
     width: 33.33%;text-align: center;margin-bottom: 20px;
      img{
        width: 134px;
        height: 134px;
        border-radius: 10px;
      }
      .title{
        font-size: 24px;margin-top: 30px;text-align: center; width: 134px;
      }
    }
  }
}
</style>
